import { Injectable } from '@angular/core';
import { HubConnection, HubConnectionBuilder, LogLevel, HttpTransportType, HubConnectionState } from '@microsoft/signalr';
import { SignalRModel, SignalRTransferModel } from '../pages/models/signalR.models';
import { observable, Observable, Subject } from 'rxjs';
import { SignalRActionNamesEnum } from '../pages/enums/ocpp-gateway.enum';
import { Router } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class SignalRService {
  hubConnection!: HubConnection;
  public chargePointData: SignalRModel | undefined;
  // Observable string sources

  private notificationSubject = new Subject<any>();
  public notifications$: Observable<any> = this.notificationSubject.asObservable();
  constructor(public router: Router) {
  }

  public async initiateSignalrConnection(): Promise<void> {
    if (!this.isHubConnectionAlive()) {
      this.hubConnection = new HubConnectionBuilder()
        .withUrl(window.location.origin + "/SendingHub",
          {
            skipNegotiation: true,
            transport: 1
          })
        .withAutomaticReconnect()
        .build();
      this.hubConnection.start()
        .then((x) => {
          console.log('Connected to SendingHub');
          this.SendingHubListning();
        }).catch(err => console.error('error signalR' + err));
      this.hubConnection.onclose(() => {
        // Handle the connection closing, and consider implementing reconnect logic.
        console.log(' SendingHub Connection closed');
      });
    }
  }

  // Service message commands
  async SendingHubListning() {
    this.hubConnection.on(SignalRActionNamesEnum[SignalRActionNamesEnum.StatusNotification], (x: any) => {
      this.notificationSubject.next({ data: x, method: SignalRActionNamesEnum[SignalRActionNamesEnum.StatusNotification] } as SignalRTransferModel);
    });
    this.hubConnection.on(SignalRActionNamesEnum[SignalRActionNamesEnum.Reset], (x: any) => {
      this.notificationSubject.next({ data: x, method: SignalRActionNamesEnum[SignalRActionNamesEnum.Reset] } as SignalRTransferModel);
    });
    this.hubConnection.on(SignalRActionNamesEnum[SignalRActionNamesEnum.UnlockConnector], (x: any) => {
      this.notificationSubject.next({ data: x, method: SignalRActionNamesEnum[SignalRActionNamesEnum.UnlockConnector] } as SignalRTransferModel);
    });
    this.hubConnection.on(SignalRActionNamesEnum[SignalRActionNamesEnum.RemoteStopTransaction], (x: any) => {
      this.notificationSubject.next({ data: x, method: SignalRActionNamesEnum[SignalRActionNamesEnum.RemoteStopTransaction] } as SignalRTransferModel);
    });
    this.hubConnection.on(SignalRActionNamesEnum[SignalRActionNamesEnum.OcppMessage], (x: any) => {
      this.notificationSubject.next({ data: x, method: SignalRActionNamesEnum[SignalRActionNamesEnum.OcppMessage] } as SignalRTransferModel);
    });
  }

  isHubConnectionAlive(): boolean {
    if (this.hubConnection) {
      return this.hubConnection.state == HubConnectionState.Connected;
    }
    return false;
  }
}
